export default class ContinueManager {

  // This comes from the mini basket. 
  _onDone = null;

  // This comes from the component that handles data before the actual click event happens.
  _process = null;

  // Used to prevent multiple calls to process function
  _loading = null;

  //set done event from basket
  static register(done) {
    this._onDone = done;
  }

  // set process from booking journey
  static setProcess(process) {
    this._process = process;
  }

  static setLoading(loading) {
    this._loading = loading;
  }

  // This get's called from mini basket.
  // If there is a process to be run then run it.
  static handleClick() {
    if (this._loading) return;
    if (this._process) {
      this._process();
    } else {
      this._onDone();
    }
  }

  // If a process has run then it should call this when finished.
  static endProcess() {
    this._onDone();
  }
}
